import { useQuery, useMutation, UseQueryOptions } from 'react-query';
import api from '../services/api';
import settingsApi from '../services/settings-api';
import newSettingsApi from '../services/new-settings-api';
import OCFApi from '../services/ocf-api';
import { AxiosResponse } from 'axios';

export const useQueryFetchCourierList = (options: any) => {
  return useQuery('couriers', api.getCouriers, {
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useLinkCourierMutation = (options: any) => {
  return useMutation(api.linkCourier, options);
};

export const useDisconnectCourierMutation = (options: any) => {
  return useMutation(api.disconnectCourier, options);
};

export const useReinviteCourierMutation = (options: any) => {
  return useMutation(api.reinviteCourier, options);
};

export const useDeclineCourierMutation = (options: any) => {
  return useMutation(api.declineCourier, options);
};
export const useConnectCourierMutation = (options: any) => {
  return useMutation(api.connectCourier, options);
};

export const useDeleteCourierMutation = (option: any) => {
  return useMutation(api.deleteCourier, {
    ...option,
  });
};

export const useQueryGetTipSettings = (options: any) => {
  return useQuery('settings', settingsApi.getTips, {
    refetchOnWindowFocus: false,
    ...options,
  });
};

export const useUpdateTips = (options: any) => {
  return useMutation(settingsApi.updateTips, options);
};

export const useShowUnassignedOrderMutation = (options: any) => {
  return useMutation(newSettingsApi.showUnassignedOrders, options);
};

export const useFetchCourierConnectionCode = (
  restaurantId: string,
  options?: Omit<UseQueryOptions<AxiosResponse<any>, unknown>, 'queryKey' | 'queryFn'>
) => {
  return useQuery('connectioncode', () => OCFApi.getCourierConnectionCode(restaurantId), options);
};

export const useRefreshCourierConnectionCode = (options: any) => {
  return useMutation(OCFApi.refreshCourierConnectionCode, options);
};
